module.exports = __webpack_public_path__ + "media/2-7.9e2a8f95.wav";